import { Stack } from '@mui/material'
import { useGetBarnList } from 'hook/query/useGetBarnList'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { useAppSelector } from 'store/hooks'
import BreadCrumbsGroup from 'ui/breadCrumbs/BreadCrumbsGroup'

type MilkYeildTabsProps = {
	selectedBarn: number | null
	setSelectedBarn: (id: number | null) => void
	setSelectedGroup: (ids: number[]) => void
}

export const MilkYeildTabs = ({
	selectedBarn,
	setSelectedBarn,
	setSelectedGroup,
}: MilkYeildTabsProps) => {
	const [selectedGroups, setSelectedGroups] = useState<number[]>([])

	const { groupList } = useAppSelector(state => state.groupsReducer)
	const { barnList, loading } = useGetBarnList()

	const barns = useMemo(() => {
		if (!barnList || loading) return []
		const isMoreThanOneBarnList = !barnList || barnList?.length > 1
		return [
			isMoreThanOneBarnList && { id: null, title: 'Все коровники' },
			...barnList,
		]
	}, [barnList, loading])

	useEffect(() => {
		setSelectedGroup(selectedGroups)
	}, [selectedGroups, setSelectedGroup])

	const handleActiveGroup = useCallback((id: number | 'all') => {
		if (id === 'all') {
			setSelectedGroups([])
			return
		}

		setSelectedGroups(prev =>
			prev.includes(id) ? prev.filter(gid => gid !== id) : [...prev, id],
		)
	}, [])

	const handleRemoveGroup = useCallback((id: number) => {
		setSelectedGroups(prev => prev.filter(gid => gid !== id))
	}, [])

	return (
		<Stack direction='column' gap='24px'>
			{/* <TabsFilter
				availableTabs={barns}
				selectedTab={selectedBarn}
				onClick={setSelectedBarn}
			/> */}
			<BreadCrumbsGroup
				allLabel='Все группы'
				handleActiveFilter={handleActiveGroup}
				handleRemoveFilter={handleRemoveGroup}
				array={groupList.map(group => ({
					...group,
					selected: selectedGroups.includes(group.id),
				}))}
			/>
		</Stack>
	)
}
